{
  "comment": "M4 station templates (spec §4.3). A template is a named module set plus a station model, a name noun and a build cost. modules[].scales: true = the module runs at the station level, false = level 1. levels: [min, max] station level. buildCost[level - 1]: tonnes per ware to build that level (refinery L1 ≈ 390k at base prices); buildDays 2-6 (the M6 range). typeMap: M3 layout station type → template (the ◆ templates, D-TBD adopt M3 station sites). m2Id: the M2 station this template plays in the home system. anchorModule (outpost): the production module chosen by the site's anchor field kind, else 'other'. basket: overrides the trade module's basket for this template (the patrol base). componentMult: the M2 component price multiplier where the station buys salvage components (null = it does not; spec §5.7). assetId: ◆ templates reuse the M2/M3 models (E6 re-points them if the M2/M3 bridge renames them); the six M4-only templates use station.<name> placeholders (spec §17). M6 (plan P6): the player station types refinery, ice_works, fabworks and hab run levels 1-3, level 3 costing 2.4× level 1 (level 2 stays 1.6×); outpost and exchange stay level 1 for now (D-TBD: raising their max shifts the M4 seeding stream, siteSource seededLevel); defense_platform is a player-only type (the patrol base without its trade module: a garrison habitat that scales with the level; its Security per level is commission.json types.defense_platform.security), never seeded. Player build days per level come from commission.json. 5(e) MC-e3 (U7, T33): the refractory alloy is in the level-3 cost of hab (10 t), ice_works (10 t), fabworks (16 t) and defense_platform (10 t) and in defense_platform's construction (level 1, 4 t); never in a cost of a template that makes it (refinery, outpost), so the first producer never waits on the import. Starting values, tune freely.",
  "typeMap": {
    "hub": "charter_hub",
    "refinery": "refinery",
    "scrapyard": "scrapyard",
    "trade-post": "exchange",
    "outpost": "outpost",
    "habitat": "hab",
    "patrol-base": "patrol_base"
  },
  "templates": [
    {
      "id": "charter_hub",
      "noun": "Charter Hub",
      "assetId": "station.hub",
      "m3Type": "hub",
      "m2Id": "hub",
      "modules": [
        { "module": "trading_post", "scales": false },
        { "module": "habitat", "scales": true }
      ],
      "levels": [1, 1],
      "buildCost": [{ "steel": 500, "hull_plating": 200, "ti_alloy": 60, "electronics": 100, "drive_parts": 20 }],
      "buildDays": 6,
      "componentMult": 1.0,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "refinery",
      "noun": "Refinery",
      "assetId": "station.refinery",
      "m3Type": "refinery",
      "m2Id": "refinery",
      "modules": [{ "module": "refinery", "scales": true }],
      "levels": [1, 3],
      "buildCost": [
        { "steel": 300, "hull_plating": 120, "ti_alloy": 40, "electronics": 60, "drive_parts": 10 },
        { "steel": 480, "hull_plating": 192, "ti_alloy": 64, "electronics": 96, "drive_parts": 16 },
        { "steel": 720, "hull_plating": 288, "ti_alloy": 96, "electronics": 144, "drive_parts": 24 }
      ],
      "buildDays": 4,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "scrapyard",
      "noun": "Scrapyard",
      "assetId": "station.scrapyard",
      "m3Type": "scrapyard",
      "m2Id": "scrapyard",
      "modules": [{ "module": "trading_post", "scales": false }],
      "levels": [1, 1],
      "buildCost": [{ "steel": 200, "hull_plating": 100, "ti_alloy": 20, "electronics": 40, "drive_parts": 10 }],
      "buildDays": 3,
      "componentMult": 1.25,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "exchange",
      "noun": "Exchange",
      "assetId": "reach.station_trade",
      "m3Type": "trade-post",
      "m2Id": null,
      "modules": [{ "module": "trading_post", "scales": false }],
      "levels": [1, 1],
      "buildCost": [{ "steel": 250, "hull_plating": 100, "ti_alloy": 20, "electronics": 80, "drive_parts": 10 }],
      "buildDays": 3,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "outpost",
      "noun": "Outpost",
      "assetId": "reach.station_outpost",
      "m3Type": "outpost",
      "m2Id": null,
      "modules": [{ "module": "trading_post", "scales": false }],
      "anchorModule": { "asteroid": "refinery", "ice": "ice_processor", "gas": "ice_processor", "other": "habitat" },
      "levels": [1, 1],
      "buildCost": [{ "steel": 150, "hull_plating": 60, "ti_alloy": 20, "electronics": 40, "drive_parts": 6 }],
      "buildDays": 2,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "hab",
      "noun": "Hab",
      "assetId": "reach.station_habitat",
      "m3Type": "habitat",
      "m2Id": null,
      "modules": [{ "module": "habitat", "scales": true }],
      "levels": [1, 3],
      "buildCost": [
        { "steel": 300, "hull_plating": 120, "ti_alloy": 30, "electronics": 60, "drive_parts": 8 },
        { "steel": 480, "hull_plating": 192, "ti_alloy": 48, "electronics": 96, "drive_parts": 13 },
        { "steel": 720, "hull_plating": 288, "ti_alloy": 72, "electronics": 144, "drive_parts": 19, "refractory_alloy": 10 }
      ],
      "buildDays": 4,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "patrol_base",
      "noun": "Patrol Base",
      "assetId": "reach.station_patrol",
      "m3Type": "patrol-base",
      "m2Id": null,
      "modules": [{ "module": "trading_post", "scales": false }],
      "basket": ["fuel_cells", "food", "medical", "weapon_parts"],
      "levels": [1, 1],
      "buildCost": [{ "steel": 250, "hull_plating": 150, "ti_alloy": 40, "electronics": 60, "drive_parts": 20, "weapon_parts": 40 }],
      "buildDays": 4,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "ice_works",
      "noun": "Ice Works",
      "assetId": "station.ice_works",
      "m3Type": null,
      "m2Id": null,
      "modules": [{ "module": "ice_processor", "scales": true }],
      "levels": [1, 3],
      "buildCost": [
        { "steel": 250, "hull_plating": 100, "ti_alloy": 30, "electronics": 50, "drive_parts": 10 },
        { "steel": 400, "hull_plating": 160, "ti_alloy": 48, "electronics": 80, "drive_parts": 16 },
        { "steel": 600, "hull_plating": 240, "ti_alloy": 72, "electronics": 120, "drive_parts": 24, "refractory_alloy": 10 }
      ],
      "buildDays": 3,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "fabworks",
      "noun": "Fabworks",
      "assetId": "station.fabworks",
      "m3Type": null,
      "m2Id": null,
      "modules": [{ "module": "fab", "scales": true }],
      "levels": [1, 3],
      "buildCost": [
        { "steel": 400, "hull_plating": 160, "ti_alloy": 80, "electronics": 120, "drive_parts": 20 },
        { "steel": 640, "hull_plating": 256, "ti_alloy": 128, "electronics": 192, "drive_parts": 32 },
        { "steel": 960, "hull_plating": 384, "ti_alloy": 192, "electronics": 288, "drive_parts": 48, "refractory_alloy": 16 }
      ],
      "buildDays": 5,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "hydro",
      "noun": "Hydro",
      "assetId": "station.hydro",
      "m3Type": null,
      "m2Id": null,
      "modules": [{ "module": "hydroponics", "scales": true }],
      "levels": [1, 2],
      "buildCost": [
        { "steel": 200, "hull_plating": 80, "ti_alloy": 20, "electronics": 60, "drive_parts": 6 },
        { "steel": 320, "hull_plating": 128, "ti_alloy": 32, "electronics": 96, "drive_parts": 10 }
      ],
      "buildDays": 3,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "clinic",
      "noun": "Clinic",
      "assetId": "station.clinic",
      "m3Type": null,
      "m2Id": null,
      "modules": [{ "module": "clinic", "scales": true }],
      "levels": [1, 1],
      "buildCost": [{ "steel": 200, "hull_plating": 80, "ti_alloy": 20, "electronics": 80, "drive_parts": 6 }],
      "buildDays": 3,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "yards",
      "noun": "Yards",
      "assetId": "station.yards",
      "m3Type": null,
      "m2Id": null,
      "modules": [
        { "module": "shipyard", "scales": true },
        { "module": "trading_post", "scales": false }
      ],
      "levels": [1, 2],
      "buildCost": [
        { "steel": 600, "hull_plating": 240, "ti_alloy": 120, "electronics": 150, "drive_parts": 40, "weapon_parts": 20 },
        { "steel": 960, "hull_plating": 384, "ti_alloy": 192, "electronics": 240, "drive_parts": 64, "weapon_parts": 32 }
      ],
      "buildDays": 6,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "export_terminal",
      "noun": "Export Terminal",
      "assetId": "station.terminal",
      "m3Type": null,
      "m2Id": null,
      "modules": [
        { "module": "export_terminal", "scales": false },
        { "module": "trading_post", "scales": false }
      ],
      "levels": [1, 1],
      "buildCost": [{ "steel": 500, "hull_plating": 200, "ti_alloy": 60, "electronics": 100, "drive_parts": 40 }],
      "buildDays": 6,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    },
    {
      "id": "raider_base",
      "noun": "Base",
      "assetId": "reach.base_raider",
      "m3Type": null,
      "m2Id": null,
      "modules": [{ "module": "fence", "scales": false }],
      "levels": [1, 1],
      "buildCost": [{ "steel": 200, "hull_plating": 120, "ti_alloy": 20, "electronics": 40, "drive_parts": 20, "weapon_parts": 40 }],
      "buildDays": 5,
      "componentMult": null,
      "dockable": false,
      "hidden": true
    },
    {
      "id": "defense_platform",
      "noun": "Defense Platform",
      "assetId": "station.defense_platform",
      "m3Type": null,
      "m2Id": null,
      "modules": [{ "module": "habitat", "scales": true }],
      "levels": [1, 3],
      "buildCost": [
        { "steel": 250, "hull_plating": 150, "ti_alloy": 40, "electronics": 60, "drive_parts": 20, "weapon_parts": 40, "refractory_alloy": 4 },
        { "steel": 400, "hull_plating": 240, "ti_alloy": 64, "electronics": 96, "drive_parts": 32, "weapon_parts": 64 },
        { "steel": 600, "hull_plating": 360, "ti_alloy": 96, "electronics": 144, "drive_parts": 48, "weapon_parts": 96, "refractory_alloy": 10 }
      ],
      "buildDays": 4,
      "componentMult": null,
      "dockable": true,
      "hidden": false
    }
  ]
}
